import makeStyle from "@utils/styles/makeStyle";
import clsx from "clsx";

import classes from "./Member.module.scss";

type PropsType = {
  img: string;
  imgHover: string;
  name: string;
  position: string;
  isActive: boolean;
};

const Member = (props: PropsType) => {
  const { img, imgHover, name, position, isActive } = props;

  const { classes: styles } = useStyles({ img, imgHover });

  return (
    <div className={clsx(classes.member, styles.member, { [classes.active]: isActive })}>
      <div className={clsx(classes.member__img, "member__img")}></div>
      <div className={classes.member__info}>
        <p className={classes.member__name}>{name}</p>
        <p className={classes.member__position}>{position}</p>
      </div>
    </div>
  );
};

export default Member;

const useStyles = makeStyle<{ img: string; imgHover: string }>()((_, props) => ({
  member: {
    "& .member__img": {
      "&::before": {
        backgroundImage: `url(${props.img})`,
      },

      "&::after": {
        backgroundImage: `url(${props.imgHover})`,
      },

      // transition: "background-image .2s ease-in-out",
    },
    // "&:hover": {
    //   "& .member__img": {
    //     backgroundImage: `url(${props.imgHover})`,
    //   },
    // },
  },
}));
